module.exports = __webpack_public_path__ + "img/2-2.1f5c4807.svg";